import React from 'react';
import {injectIntl} from 'react-intl';

import BusComponent from '../BusComponent';
import TypeDropdown from "../dataFilter/TypeDropdown";

/**
 * @typedef State
 * @property {import('../../').PointsFilterField[]} filters
 *
 * @typedef Props
 * @property {import('react-intl').intlShape} intl
 * @property {() => void} addCriterion
 * @property {import('../../').PointsFilterField[]} addedCriteria
 *
 * @extends {BusComponent<Props, State>}
 */
class NewCriterion extends BusComponent {
    constructor(props) {
        super(props);
        /** @type {State} */
        this.state = {
            filters: [],
        };
    }

    componentDidMount() {
        this.bindGluBusEvents({
            POINTS_FILTERS_RESPONSE: this.onPointsFiltersResponse,
        });
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    /**
     *
     * @param {import('../../').PointsFilterField[]} filters
     */
    onPointsFiltersResponse = filters => {
        this.setState({ filters });
    };

    onDropdownChange = selectedProperty => {
        const { filters } = this.state;
        const { addCriterion } = this.props;

        const selectedFilter = filters.find(f => f.property === selectedProperty);
        if (selectedFilter) {
            addCriterion(selectedFilter);
        }
        this.setState({ showDropdown: false });
    };

    render() {
        const { addedCriteria, intl } = this.props;
        const { filters } = this.state;


        const availableFilters = filters.filter(
            filter => !addedCriteria.some(c => c.property === filter.property)
        );

        if (!availableFilters.length) return null;

        return (
            <div className="points-filter-panel__criterion-dropdown">
                <TypeDropdown
                    types={availableFilters.map(f => ({
                        type: f.property,
                        text: f.label,
                    }))}
                    value={undefined}
                    onChange={this.onDropdownChange}
                    placeholder={intl.formatMessage({ id: 'points.addCriterion' })}
                    dropdownClassName="simple-dropdown--primary-rounded"
                />
            </div>
        );
    }
}

export default injectIntl(NewCriterion);
